import script from "./base-date-input.vue?vue&type=script&setup=true&lang=js"
export * from "./base-date-input.vue?vue&type=script&setup=true&lang=js"

import "./base-date-input.vue?vue&type=style&index=0&id=0641e0e6&lang=scss"

const __exports__ = script;

export default __exports__